<script>
	import { onMount } from 'svelte';
	import { Map, AttributionControl, NavigationControl, GeolocateControl } from 'mapbox-gl';
	
	export let location = {
		bounds: [[-5.816, 49.864], [1.863, 55.872]] // England & Wales bounding box
	};
	export let style;
	export let map;
	export let side = 'left';
	
	let container;
	let options;
	
	if (location.bounds) {
		options = { bounds: location.bounds };
	} else if (location.lon && location.lat) {
		options = {
			center: [location.lon, location.lat]
		}
		if (location.zoom) {
			options.zoom = location.zoom;
		}
	};
	
	if (side == 'left') {
		options.attributionControl = false;
	}
	
	onMount(() => {
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = 'https://unpkg.com/mapbox-gl/dist/mapbox-gl.css';

		link.onload = () => {
			map = new Map({
				container: container,
				style: style,
				maxZoom: 17,
				...options
			});
			if (side == 'left') {
				map.addControl(new AttributionControl(), 'bottom-left');
			} else {
				map.addControl(new NavigationControl({showCompass: false}), 'bottom-right');
				map.addControl(new GeolocateControl(), 'bottom-right');
			}
		};

		document.head.appendChild(link);

		return () => {
			map.remove();
			link.parentNode.removeChild(link);
		};
	});
</script>

<style>
	div {
		position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
	}
</style>

<div bind:this={container}>
	{#if map}
		<slot></slot>
	{/if}
</div>